import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ErrorListener } from "@sdk/helpers";
import { StateItems } from "@sdk/state/types";
import { FunctionErrorCheckoutTypes } from "./types";
export var SaleorCheckoutAPI =
/*#__PURE__*/
function (_ErrorListener) {
  _inherits(SaleorCheckoutAPI, _ErrorListener);

  function SaleorCheckoutAPI(saleorState, loadOnStart, jobsManager) {
    var _this;

    _classCallCheck(this, SaleorCheckoutAPI);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SaleorCheckoutAPI).call(this));
    _this.load =
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.saleorState.provideCheckout(_this.fireError, true);

            case 2:
              _context.next = 4;
              return _this.saleorState.providePayment(true);

            case 4:
              _context.next = 6;
              return _this.saleorState.providePaymentGateways(_this.fireError);

            case 6:
              return _context.abrupt("return", {
                pending: false
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    _this.setShippingAddress =
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(shippingAddress, email) {
        var _this$saleorState$che, _this$saleorState$che2, _this$saleorState$che3;

        var checkoutId, alteredLines, _ref3, data, dataError, _this$saleorState$che4, _ref4, _data, _dataError;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.saleorState.provideCheckout(_this.fireError);

              case 2:
                checkoutId = (_this$saleorState$che = _this.saleorState.checkout) === null || _this$saleorState$che === void 0 ? void 0 : _this$saleorState$che.id;
                alteredLines = (_this$saleorState$che2 = _this.saleorState.checkout) === null || _this$saleorState$che2 === void 0 ? void 0 : (_this$saleorState$che3 = _this$saleorState$che2.lines) === null || _this$saleorState$che3 === void 0 ? void 0 : _this$saleorState$che3.map(function (item) {
                  return {
                    productAttributes: item.productAttributes || [],
                    quantity: item.quantity,
                    variantId: item.variant.id
                  };
                });

                if (!(alteredLines && checkoutId)) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 7;
                return _this.jobsManager.run("checkout", "setShippingAddress", {
                  checkoutId: checkoutId,
                  email: email,
                  selectedShippingAddressId: shippingAddress.id,
                  shippingAddress: shippingAddress
                });

              case 7:
                _ref3 = _context2.sent;
                data = _ref3.data;
                dataError = _ref3.dataError;
                return _context2.abrupt("return", {
                  data: data,
                  dataError: dataError,
                  pending: false
                });

              case 11:
                if (!alteredLines) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 14;
                return _this.jobsManager.run("checkout", "createCheckout", {
                  cartPromoCode: (_this$saleorState$che4 = _this.saleorState.checkout) === null || _this$saleorState$che4 === void 0 ? void 0 : _this$saleorState$che4.cartPromoCode,
                  email: email,
                  lines: alteredLines,
                  selectedShippingAddressId: shippingAddress.id,
                  shippingAddress: shippingAddress
                });

              case 14:
                _ref4 = _context2.sent;
                _data = _ref4.data;
                _dataError = _ref4.dataError;
                return _context2.abrupt("return", {
                  data: _data,
                  dataError: _dataError,
                  pending: false
                });

              case 18:
                return _context2.abrupt("return", {
                  functionError: {
                    error: new Error("You need to add items to cart before setting shipping address."),
                    type: FunctionErrorCheckoutTypes.ITEMS_NOT_ADDED_TO_CART
                  },
                  pending: false
                });

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.setBillingAddress =
    /*#__PURE__*/
    function () {
      var _ref5 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(billingAddress, email) {
        var _this$saleorState$che5, _this$saleorState$che6, _this$saleorState$che7, _this$saleorState$che8, _this$saleorState$che9, _this$checkout;

        var checkoutId, isShippingRequiredForProducts, alteredLines, _ref7, data, dataError, _ref8, _data2, _dataError2, _this$saleorState$che10, _ref9, _data3, _dataError3;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this.saleorState.provideCheckout(_this.fireError);

              case 2:
                checkoutId = (_this$saleorState$che5 = _this.saleorState.checkout) === null || _this$saleorState$che5 === void 0 ? void 0 : _this$saleorState$che5.id;
                isShippingRequiredForProducts = (_this$saleorState$che6 = _this.saleorState.checkout) === null || _this$saleorState$che6 === void 0 ? void 0 : (_this$saleorState$che7 = _this$saleorState$che6.lines) === null || _this$saleorState$che7 === void 0 ? void 0 : _this$saleorState$che7.filter(function (line) {
                  return line.quantity > 0;
                }).some(function (_ref6) {
                  var _variant$product;

                  var variant = _ref6.variant;
                  return (_variant$product = variant.product) === null || _variant$product === void 0 ? void 0 : _variant$product.productType.isShippingRequired;
                });
                alteredLines = (_this$saleorState$che8 = _this.saleorState.checkout) === null || _this$saleorState$che8 === void 0 ? void 0 : (_this$saleorState$che9 = _this$saleorState$che8.lines) === null || _this$saleorState$che9 === void 0 ? void 0 : _this$saleorState$che9.map(function (item) {
                  return {
                    productAttributes: item.productAttributes || [],
                    quantity: item.quantity,
                    variantId: item.variant.id
                  };
                });

                if (!(isShippingRequiredForProducts && checkoutId && ((_this$checkout = _this.checkout) === null || _this$checkout === void 0 ? void 0 : _this$checkout.shippingAddress))) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 8;
                return _this.jobsManager.run("checkout", "setBillingAddress", {
                  billingAddress: billingAddress,
                  billingAsShipping: false,
                  checkoutId: checkoutId,
                  selectedBillingAddressId: billingAddress.id
                });

              case 8:
                _ref7 = _context3.sent;
                data = _ref7.data;
                dataError = _ref7.dataError;
                return _context3.abrupt("return", {
                  data: data,
                  dataError: dataError,
                  pending: false
                });

              case 12:
                if (!isShippingRequiredForProducts) {
                  _context3.next = 14;
                  break;
                }

                return _context3.abrupt("return", {
                  functionError: {
                    error: new Error("You need to set shipping address before setting billing address."),
                    type: FunctionErrorCheckoutTypes.SHIPPING_ADDRESS_NOT_SET
                  },
                  pending: false
                });

              case 14:
                if (!(!isShippingRequiredForProducts && email && checkoutId && alteredLines)) {
                  _context3.next = 21;
                  break;
                }

                _context3.next = 17;
                return _this.jobsManager.run("checkout", "setBillingAddressWithEmail", {
                  billingAddress: billingAddress,
                  checkoutId: checkoutId,
                  email: email,
                  selectedBillingAddressId: billingAddress.id
                });

              case 17:
                _ref8 = _context3.sent;
                _data2 = _ref8.data;
                _dataError2 = _ref8.dataError;
                return _context3.abrupt("return", {
                  data: _data2,
                  dataError: _dataError2,
                  pending: false
                });

              case 21:
                if (!(!isShippingRequiredForProducts && email && alteredLines)) {
                  _context3.next = 28;
                  break;
                }

                _context3.next = 24;
                return _this.jobsManager.run("checkout", "createCheckout", {
                  billingAddress: billingAddress,
                  cartPromoCode: (_this$saleorState$che10 = _this.saleorState.checkout) === null || _this$saleorState$che10 === void 0 ? void 0 : _this$saleorState$che10.cartPromoCode,
                  email: email,
                  lines: alteredLines,
                  selectedBillingAddressId: billingAddress.id
                });

              case 24:
                _ref9 = _context3.sent;
                _data3 = _ref9.data;
                _dataError3 = _ref9.dataError;
                return _context3.abrupt("return", {
                  data: _data3,
                  dataError: _dataError3,
                  pending: false
                });

              case 28:
                if (!(!isShippingRequiredForProducts && !email)) {
                  _context3.next = 30;
                  break;
                }

                return _context3.abrupt("return", {
                  functionError: {
                    error: new Error("You need to provide email when products do not require shipping before setting billing address."),
                    type: FunctionErrorCheckoutTypes.EMAIL_NOT_SET
                  },
                  pending: false
                });

              case 30:
                return _context3.abrupt("return", {
                  functionError: {
                    error: new Error("You need to add items to cart before setting billing address."),
                    type: FunctionErrorCheckoutTypes.ITEMS_NOT_ADDED_TO_CART
                  },
                  pending: false
                });

              case 31:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3, _x4) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.setNotes =
    /*#__PURE__*/
    function () {
      var _ref10 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(notes) {
        var _this$saleorState$che11;

        var checkoutId, _ref11, data, dataError;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this.saleorState.provideCheckout(_this.fireError);

              case 2:
                checkoutId = (_this$saleorState$che11 = _this.saleorState.checkout) === null || _this$saleorState$che11 === void 0 ? void 0 : _this$saleorState$che11.id;

                if (checkoutId) {
                  _context4.next = 6;
                  break;
                }

                console.error("No checkoutId");
                return _context4.abrupt("return", {
                  pending: false
                });

              case 6:
                _context4.next = 8;
                return _this.jobsManager.run("checkout", "setNotes", {
                  checkoutId: checkoutId,
                  notes: notes
                });

              case 8:
                _ref11 = _context4.sent;
                data = _ref11.data;
                dataError = _ref11.dataError;
                return _context4.abrupt("return", {
                  data: data,
                  dataError: dataError,
                  pending: false
                });

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x5) {
        return _ref10.apply(this, arguments);
      };
    }();

    _this.setBillingAsShippingAddress =
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5() {
      var _this$saleorState$che12, _this$checkout2;

      var checkoutId, _this$checkout3, _ref13, data, dataError;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this.saleorState.provideCheckout(_this.fireError);

            case 2:
              checkoutId = (_this$saleorState$che12 = _this.saleorState.checkout) === null || _this$saleorState$che12 === void 0 ? void 0 : _this$saleorState$che12.id;

              if (!(checkoutId && ((_this$checkout2 = _this.checkout) === null || _this$checkout2 === void 0 ? void 0 : _this$checkout2.shippingAddress))) {
                _context5.next = 10;
                break;
              }

              _context5.next = 6;
              return _this.jobsManager.run("checkout", "setBillingAddress", {
                billingAddress: _this.checkout.shippingAddress,
                billingAsShipping: true,
                checkoutId: checkoutId,
                selectedBillingAddressId: (_this$checkout3 = _this.checkout) === null || _this$checkout3 === void 0 ? void 0 : _this$checkout3.shippingAddress.id
              });

            case 6:
              _ref13 = _context5.sent;
              data = _ref13.data;
              dataError = _ref13.dataError;
              return _context5.abrupt("return", {
                data: data,
                dataError: dataError,
                pending: false
              });

            case 10:
              return _context5.abrupt("return", {
                functionError: {
                  error: new Error("You need to set shipping address before setting billing address."),
                  type: FunctionErrorCheckoutTypes.SHIPPING_ADDRESS_NOT_SET
                },
                pending: false
              });

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    _this.setShippingMethod =
    /*#__PURE__*/
    function () {
      var _ref14 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(shippingMethodId) {
        var _this$saleorState$che13;

        var checkoutId, _ref15, data, dataError;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this.saleorState.provideCheckout(_this.fireError);

              case 2:
                checkoutId = (_this$saleorState$che13 = _this.saleorState.checkout) === null || _this$saleorState$che13 === void 0 ? void 0 : _this$saleorState$che13.id;

                if (!checkoutId) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 6;
                return _this.jobsManager.run("checkout", "setShippingMethod", {
                  checkoutId: checkoutId,
                  shippingMethodId: shippingMethodId
                });

              case 6:
                _ref15 = _context6.sent;
                data = _ref15.data;
                dataError = _ref15.dataError;
                return _context6.abrupt("return", {
                  data: data,
                  dataError: dataError,
                  pending: false
                });

              case 10:
                return _context6.abrupt("return", {
                  functionError: {
                    error: new Error("You need to set shipping address before setting shipping method."),
                    type: FunctionErrorCheckoutTypes.SHIPPING_ADDRESS_NOT_SET
                  },
                  pending: false
                });

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x6) {
        return _ref14.apply(this, arguments);
      };
    }();

    _this.addPromoCode =
    /*#__PURE__*/
    function () {
      var _ref16 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(promoCode) {
        var _this$saleorState$che14;

        var checkoutId, _ref17, data, dataError;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this.saleorState.provideCheckout(_this.fireError);

              case 2:
                checkoutId = (_this$saleorState$che14 = _this.saleorState.checkout) === null || _this$saleorState$che14 === void 0 ? void 0 : _this$saleorState$che14.id;

                if (!checkoutId) {
                  _context7.next = 10;
                  break;
                }

                _context7.next = 6;
                return _this.jobsManager.run("checkout", "addPromoCode", {
                  checkoutId: checkoutId,
                  promoCode: promoCode
                });

              case 6:
                _ref17 = _context7.sent;
                data = _ref17.data;
                dataError = _ref17.dataError;
                return _context7.abrupt("return", {
                  data: data,
                  dataError: dataError,
                  pending: false
                });

              case 10:
                return _context7.abrupt("return", {
                  functionError: {
                    error: new Error("You need to set shipping address before modifying promo code."),
                    type: FunctionErrorCheckoutTypes.SHIPPING_ADDRESS_NOT_SET
                  },
                  pending: false
                });

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x7) {
        return _ref16.apply(this, arguments);
      };
    }();

    _this.removePromoCode =
    /*#__PURE__*/
    function () {
      var _ref18 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(promoCode) {
        var _this$saleorState$che15;

        var checkoutId, _ref19, data, dataError;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this.saleorState.provideCheckout(_this.fireError);

              case 2:
                checkoutId = (_this$saleorState$che15 = _this.saleorState.checkout) === null || _this$saleorState$che15 === void 0 ? void 0 : _this$saleorState$che15.id;

                if (!checkoutId) {
                  _context8.next = 10;
                  break;
                }

                _context8.next = 6;
                return _this.jobsManager.run("checkout", "removePromoCode", {
                  checkoutId: checkoutId,
                  promoCode: promoCode
                });

              case 6:
                _ref19 = _context8.sent;
                data = _ref19.data;
                dataError = _ref19.dataError;
                return _context8.abrupt("return", {
                  data: data,
                  dataError: dataError,
                  pending: false
                });

              case 10:
                return _context8.abrupt("return", {
                  functionError: {
                    error: new Error("You need to set shipping address before modifying promo code."),
                    type: FunctionErrorCheckoutTypes.SHIPPING_ADDRESS_NOT_SET
                  },
                  pending: false
                });

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function (_x8) {
        return _ref18.apply(this, arguments);
      };
    }();

    _this.createPayment =
    /*#__PURE__*/
    function () {
      var _ref20 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(gateway, token, creditCard) {
        var _this$saleorState$che16, _this$saleorState$che17, _this$saleorState$sum, _this$saleorState$sum2;

        var checkoutId, billingAddress, amount, _ref21, data, dataError;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this.saleorState.provideCheckout(_this.fireError);

              case 2:
                _context9.next = 4;
                return _this.saleorState.providePayment();

              case 4:
                checkoutId = (_this$saleorState$che16 = _this.saleorState.checkout) === null || _this$saleorState$che16 === void 0 ? void 0 : _this$saleorState$che16.id;
                billingAddress = (_this$saleorState$che17 = _this.saleorState.checkout) === null || _this$saleorState$che17 === void 0 ? void 0 : _this$saleorState$che17.billingAddress;
                amount = (_this$saleorState$sum = _this.saleorState.summaryPrices) === null || _this$saleorState$sum === void 0 ? void 0 : (_this$saleorState$sum2 = _this$saleorState$sum.totalPrice) === null || _this$saleorState$sum2 === void 0 ? void 0 : _this$saleorState$sum2.gross.amount;

                if (!(checkoutId && billingAddress && amount !== null && amount !== undefined)) {
                  _context9.next = 14;
                  break;
                }

                _context9.next = 10;
                return _this.jobsManager.run("checkout", "createPayment", {
                  amount: amount,
                  billingAddress: billingAddress,
                  checkoutId: checkoutId,
                  creditCard: creditCard,
                  paymentGateway: gateway,
                  paymentToken: token
                });

              case 10:
                _ref21 = _context9.sent;
                data = _ref21.data;
                dataError = _ref21.dataError;
                return _context9.abrupt("return", {
                  data: data,
                  dataError: dataError,
                  pending: false
                });

              case 14:
                return _context9.abrupt("return", {
                  functionError: {
                    error: new Error("You need to set billing address before creating payment."),
                    type: FunctionErrorCheckoutTypes.SHIPPING_ADDRESS_NOT_SET
                  },
                  pending: false
                });

              case 15:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function (_x9, _x10, _x11) {
        return _ref20.apply(this, arguments);
      };
    }();

    _this.completeCheckout =
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee10() {
      var _this$saleorState$che18;

      var checkoutId, _ref23, data, dataError;

      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _this.saleorState.provideCheckout(_this.fireError);

            case 2:
              checkoutId = (_this$saleorState$che18 = _this.saleorState.checkout) === null || _this$saleorState$che18 === void 0 ? void 0 : _this$saleorState$che18.id;

              if (!checkoutId) {
                _context10.next = 10;
                break;
              }

              _context10.next = 6;
              return _this.jobsManager.run("checkout", "completeCheckout", {
                checkoutId: checkoutId
              });

            case 6:
              _ref23 = _context10.sent;
              data = _ref23.data;
              dataError = _ref23.dataError;
              return _context10.abrupt("return", {
                data: data,
                dataError: dataError,
                pending: false
              });

            case 10:
              return _context10.abrupt("return", {
                functionError: {
                  error: new Error("You need to set shipping address before creating payment."),
                  type: FunctionErrorCheckoutTypes.SHIPPING_ADDRESS_NOT_SET
                },
                pending: false
              });

            case 11:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));
    _this.saleorState = saleorState;
    _this.jobsManager = jobsManager;
    _this.loaded = false;
    _this.checkoutLoaded = false;
    _this.paymentLoaded = false;
    _this.paymentGatewaysLoaded = false;

    _this.saleorState.subscribeToChange(StateItems.CHECKOUT, function (_ref24) {
      var id = _ref24.id,
          token = _ref24.token,
          email = _ref24.email,
          shippingAddress = _ref24.shippingAddress,
          billingAddress = _ref24.billingAddress,
          selectedShippingAddressId = _ref24.selectedShippingAddressId,
          selectedBillingAddressId = _ref24.selectedBillingAddressId,
          billingAsShipping = _ref24.billingAsShipping,
          availableShippingMethods = _ref24.availableShippingMethods,
          shippingMethod = _ref24.shippingMethod,
          promoCodeDiscount = _ref24.promoCodeDiscount,
          deliveryNote = _ref24.deliveryNote,
          note = _ref24.note;
      _this.checkout = {
        billingAddress: billingAddress,
        deliveryNote: deliveryNote,
        email: email,
        id: id,
        note: note,
        shippingAddress: shippingAddress,
        shippingMethod: shippingMethod,
        token: token
      };
      _this.selectedShippingAddressId = selectedShippingAddressId;
      _this.selectedBillingAddressId = selectedBillingAddressId;
      _this.availableShippingMethods = availableShippingMethods;
      _this.billingAsShipping = billingAsShipping;
      _this.promoCodeDiscount = {
        discountName: promoCodeDiscount === null || promoCodeDiscount === void 0 ? void 0 : promoCodeDiscount.discountName,
        voucherCode: promoCodeDiscount === null || promoCodeDiscount === void 0 ? void 0 : promoCodeDiscount.voucherCode
      };
      _this.checkoutLoaded = true;
      _this.loaded = _this.checkoutLoaded && _this.paymentLoaded && _this.paymentGatewaysLoaded;
    });

    _this.saleorState.subscribeToChange(StateItems.PAYMENT, function (_ref25) {
      var id = _ref25.id,
          token = _ref25.token,
          gateway = _ref25.gateway,
          creditCard = _ref25.creditCard;
      _this.payment = {
        creditCard: creditCard,
        gateway: gateway,
        id: id,
        token: token
      };
      _this.paymentLoaded = true;
      _this.loaded = _this.paymentLoaded && _this.checkoutLoaded && _this.paymentGatewaysLoaded;
    });

    _this.saleorState.subscribeToChange(StateItems.PAYMENT_GATEWAYS, function (paymentGateways) {
      _this.availablePaymentGateways = paymentGateways;
      _this.paymentGatewaysLoaded = true;
      _this.loaded = _this.paymentGatewaysLoaded && _this.paymentLoaded && _this.checkoutLoaded;
    });

    if (loadOnStart) {
      _this.load();
    }

    return _this;
  }

  return SaleorCheckoutAPI;
}(ErrorListener);